var React = require('react');

function Reload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3539 6.53926L12.8136 3.83738L10.0982 1.37305M12.828 3.85166C11.2628 3.68458 9.63405 3.96202 8.13795 4.74512C4.11183 6.85249 2.57071 11.8237 4.69576 15.8487C6.82082 19.8737 11.8073 21.4282 15.8334 19.3208C18.6494 17.8469 20.2497 14.972 20.2302 11.9998","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Reload.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Reload;

Reload.default = Reload;
